import { useEffect } from 'react';
import { CustomerIOEvents } from '@/helpers/customerio';
import { useCustomerIO } from '@/hooks/3dParty/customerIO';
import { useGetCommonStore } from '@/store';
import { checkStandalone, trackStandaloneChange } from '../helpers';

const pwaOpenedEventsFired = () =>
  localStorage.getItem('pwaOpenedEventsFired_v2') === 'true';

export const usePwaOpened = () => {
  const { trackCustomEvent } = useCustomerIO();
  const useCommonStore = useGetCommonStore();

  const userId = useCommonStore((s) => s.user?.id);

  // First login in PWA (customer.io requires userId)
  useEffect(() => {
    const isStandalone = checkStandalone();
    if (!pwaOpenedEventsFired() && isStandalone && userId) {
      trackCustomEvent(CustomerIOEvents.PWA_OPENED);
      localStorage.setItem('pwaOpenedEventsFired_v2', 'true');
    }
  }, [trackCustomEvent, userId]);

  // Opened PWA with shared localstorage
  useEffect(() => {
    const unsubscribe = trackStandaloneChange((isStandalone) => {
      if (!pwaOpenedEventsFired() && isStandalone && userId) {
        trackCustomEvent(CustomerIOEvents.PWA_OPENED);
        localStorage.setItem('pwaOpenedEventsFired_v2', 'true');
      }
    });
    return unsubscribe;
  }, [trackCustomEvent, userId]);
};
